"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const big_js_1 = __importDefault(require("big.js"));
const orig = { ...big_js_1.default.prototype };
const overrides = {
    toFixed: function (dp, rm = big_js_1.default.RM) {
        //check for values that exceed the maximum value of the Big.js library
        if (!this.eq('0') && // non-zero
            (this.abs().gt('1e+1000') || // very large
                this.abs().lt('1e-1000') || // very small
                // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
                Math.max(Math.abs(this.e), this.c.length) > 1e1000) // lots of decimals
        ) {
            throw new Error('[Big] Invalid number');
        }
        else {
            return orig.toFixed.apply(this, [dp, rm]);
        }
    },
    round: function (dp, rm = big_js_1.default.RM) {
        if (!this.eq('0') && // non-zero
            (this.abs().gt('1e+1000') || // very large
                // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
                Math.max(Math.abs(this.e), this.c.length) > 1e1000) // lots of decimals
        ) {
            throw new Error('[Big] Invalid number');
        }
        else {
            return orig.round.apply(this, [dp, rm]);
        }
    },
};
for (const [key, value] of Object.entries(overrides)) {
    big_js_1.default.prototype[key] = value;
}
// Important to copy instances using this.constructor to preserve constructor copying via calling constructor with no args
const extensions = {
    flipSign: function () {
        const output = new this.constructor(this);
        output.s = output.s === 1 ? -1 : 1;
        return output;
    },
    flipExponent: function () {
        const output = new this.constructor(this);
        output.e *= -1;
        return output;
    },
    setPos: function () {
        const output = new this.constructor(this);
        output.s = 1;
        return output;
    },
    setNeg: function () {
        const output = new this.constructor(this);
        output.s = -1;
        return output;
    },
    dollarsToCents: function () {
        return this.pow10(2);
    },
    centsToDollars: function () {
        return this.pow10(-2);
    },
    bitcoinToSatoshi: function () {
        return this.pow10(8);
    },
    satoshiToBitcoin: function () {
        return this.pow10(-8);
    },
    ethToWei: function () {
        return this.pow10(18);
    },
    weiToEth: function () {
        return this.pow10(-18);
    },
    weiToTokenDecimal: function (tokenDecimal) {
        return this.pow10(-tokenDecimal);
    },
    pow10: function (modifier) {
        const output = new this.constructor(this);
        output.e += modifier;
        return output;
    },
    setExp: function (exponent) {
        return new this.constructor(10).pow(exponent).mul(this);
    },
    toDBPrecision: function (roundingMode = big_js_1.default.roundDown) {
        // use DECIMAL(36, 18) throughout mysql tables
        return new this.constructor(this.round(18, roundingMode));
    },
    toMinimumDecimalPlaces: function (minimum, maximum, roundingMode = big_js_1.default.roundDown) {
        let output = this.round(maximum, roundingMode).toString();
        const split = output.split('.');
        // If there's not enough decimal places, or no decimal places
        if ((split.length > 1 && split?.[1]?.length < minimum) || !(split.length > 1)) {
            // Append dot if necessary, then append 0's until minimum length is reached
            output += `${output.includes('.') ? '' : '.'}${'0'.repeat(minimum - (split?.[1]?.length || 0))}`;
        }
        return output;
    },
    toDecimalsWithCommas: function (maxDecimals = 2, minDecimals = 2, roundingMode = big_js_1.default.roundDown) {
        const withoutCommas = this.toMinimumDecimalPlaces(minDecimals, maxDecimals, roundingMode);
        const parts = withoutCommas.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.length > 1 && parts[1].length > 0 ? parts.join('.') : parts[0]; // Only join if we have decimal places
    },
};
for (const [key, value] of Object.entries(extensions)) {
    big_js_1.default.prototype[key] = value;
}
//# sourceMappingURL=extensions.js.map